module.exports = __webpack_public_path__ + "static/sarah-41c110702662f41bd4f08af5ae2cc70d.png";